
import { defineComponent, computed } from "vue";
import { toolbarWidthFluid } from "@/core/helpers/config";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
    title: String,
    routeKey: String,
  },
  setup(props) {
    const store = useStore();

    const saveOrderChanged = () => {
      store.dispatch(Actions.SET_LIST_ORDER, { key: props.routeKey });
    };
    const cancelOrderChanged = () => {
      window.location.reload();
    };

    const getMapping = computed(() => {
      return store.getters.getMapping({ key: props.routeKey });
    });
    const sortableListChanged = computed(() => {
      return store.getters.getSortableListChanged({ key: props.routeKey });
    });
    const getAddLink = computed(() => {
      return store.getters.getAddLink({ key: props.routeKey });
    });
    const createModal = () => {
      store.dispatch(Actions.SETUP_FORM_COMPONENT_OR_MODAL, {
        key: props.routeKey,
      });
    };

    return {
      toolbarWidthFluid,
      getMapping,
      getAddLink,
      createModal,
      sortableListChanged,
      saveOrderChanged,
      cancelOrderChanged,
    };
  },
});
